import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useMemo, useEffect } from 'react';

const RTE = ({value, setValue}) => {
    const modules = useMemo(() => ({
        toolbar: [
            ['bold', 'italic', 'underline'],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            ['link'],
            ['clean']
        ],
  }), []);
  useEffect(() => {
    // A mapping of Quill class names to their accessible labels
    const buttonLabels = {
      'ql-bold': 'Bold',
      'ql-italic': 'Italic',
      'ql-underline': 'Underline',
      'ql-strike': 'Strikethrough',
      'ql-list[value="ordered"]': 'Numbered List',
      'ql-list[value="bullet"]': 'Bulleted List',
      'ql-link': 'Insert Link',
      'ql-image': 'Insert Image',
      'ql-video': 'Insert Video',
      'ql-clean': 'Clear Formatting'
    };

    // Iterate through the map and attach labels to the generated buttons
    Object.keys(buttonLabels).forEach((selector) => {
      const buttons = document.querySelectorAll(`.ql-toolbar button.${selector}`);
      buttons.forEach((button) => {
        button.setAttribute('aria-label', buttonLabels[selector]);
        button.setAttribute('title', buttonLabels[selector]);
      });
    });

    // Handle dropdowns (like headers, fonts, color pickers)
    const pickers = document.querySelectorAll('.ql-toolbar .ql-picker-label');
    pickers.forEach((picker) => {
      // You can get more specific here based on the picker type
      picker.setAttribute('aria-label', 'Formatting options dropdown'); 
      picker.setAttribute('role', 'button');
    });

    const items = document.querySelectorAll('[data-link="https://quilljs.com"]');

    items.forEach((picker) => {
      picker.setAttribute('aria-label', 'Data'); 
      picker.setAttribute('title', 'Data');
    });
    document.querySelector('.ql-preview').innerHTML = 'Preview';
  }, []);
  return <ReactQuill theme="snow" value={value} onChange={setValue} modules={modules} />;
}

export default RTE;